import cntl from "cntl";
import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

function NavMenuFooterBase({ children }) {
  const footerCn = () => cntl`
    bg-grey-50
  `;

  const container = () => cntl`
    p-9
    flex
    mx-auto
    flex-row
    container
  `;

  return (
    <div className={footerCn()}>
      <div className={container()}>{children}</div>
    </div>
  );
}

NavMenuFooterBase.propTypes = propTypes;
export default NavMenuFooterBase;
